import {NgModule} from '@angular/core'
import {CategoryLandingPageComponent} from './category-landing-page.component'
import {CategoryLandingPageRoutingModule} from './category-landing-page-routing.module'
import {AsyncPipe, NgOptimizedImage, NgTemplateOutlet} from '@angular/common'
import {BannerComponent} from './banner/banner.component'
import {RichTextModule} from '../../../shared/components/rich-text/rich-text.module'
import {TranslocoDirective} from '@ngneat/transloco'
import {PipesModule} from '../../../shared/pipes/pipes.module'
import {HeroCoverModule} from '../../../shared/components/hero-cover/hero-cover.module'
import {FaIconComponent} from '@fortawesome/angular-fontawesome'
import {StickyBottomNavigationModule} from '../../../shared/components/sticky-bottom-navigation/sticky-bottom-navigation.module'
import {KnowledgeSectionComponent} from '../../../shared/components/content/knowledge-section/knowledge-section.component'
import {PresentationSectionComponent} from '../../../shared/components/presentation-section/presentation-section.component'
import {
  CategoryLandingPageContentComponent,
  ContentTemplateDirective,
} from './category-landing-page-content/category-landing-page-content.component'
import {ProDirectorySectionComponent} from '../../../shared/components/content/pro-directory-section/pro-directory-section.component'
import {SupportSectionComponent} from '../../../shared/components/content/support-section/support-section.component'
import {HowItWorksSectionComponent} from '../../../shared/components/content/how-it-works-section/how-it-works-section.component'
import {IndustrySectionComponent} from '../../../shared/components/content/industry-section/industry-section.component'
import {InspirationSectionComponent} from '../../../shared/components/content/inspiration-section/inspiration-section.component'
import {PartnersComponent} from '../../../craft/partners/partners.component'
import {PromotionalBannerSectionComponent} from '../../../shared/components/content/promotional-banner-section/promotional-banner-section.component'
import {OfferingsSectionComponent} from '../../../shared/components/content/offerings-section/offerings-section.component'
import {ReviewsSectionComponent} from '../../../shared/components/content/reviews-section/reviews-section.component'
import {ServicesSectionComponent} from '../../../shared/components/content/services-section/services-section.component'
import {ContentSectionComponent} from '../../../craft/content-section/content-section.component'
import {HeroSellingPointComponent} from '../../../shared/components/hero-cover/hero-selling-point/hero-selling-point.component'
import {LeadSignupSectionComponent} from '../../../shared/components/content/lead-signup-section/lead-signup-section.component'
import {ButtonModule} from '../../../craft/button/button.module'
import {IFrameSectionComponent} from '../../../shared/components/content/iframe-section/iframe-section.component'
import {VideoSectionComponent} from '../../../shared/components/content/video-section/video-section.component'

@NgModule({
  declarations: [CategoryLandingPageComponent, BannerComponent, CategoryLandingPageContentComponent],
  imports: [
    StickyBottomNavigationModule,
    AsyncPipe,
    TranslocoDirective,
    NgTemplateOutlet,
    ContentTemplateDirective,
    HowItWorksSectionComponent,
    IndustrySectionComponent,
    InspirationSectionComponent,
    PartnersComponent,
    PromotionalBannerSectionComponent,
    ReviewsSectionComponent,
    ServicesSectionComponent,
    SupportSectionComponent,
    KnowledgeSectionComponent,
    PresentationSectionComponent,
    OfferingsSectionComponent,
    ContentSectionComponent,
    RichTextModule,
    ProDirectorySectionComponent,
    HeroCoverModule,
    FaIconComponent,
    PipesModule,
    NgOptimizedImage,
    CategoryLandingPageRoutingModule,
    HeroSellingPointComponent,
    LeadSignupSectionComponent,
    ButtonModule,
    IFrameSectionComponent,
    VideoSectionComponent,
  ],
})
export default class CategoryLandingPageModule {}
